export const operateThumbnails = () => {
    const mediaQuery = window.matchMedia('(min-width: 992px)');
    const roots = Array.from(document.querySelectorAll('.operate'));

    if (!roots.length) {
        return;
    }

    roots.forEach((root) => {
        const listItems = Array.from(root.querySelectorAll('.operate__list .item'));
        const thumbnails = Array.from(root.querySelectorAll('.operate__thumbnails .operate__thumbnail'));

        if (!listItems.length || !thumbnails.length) {
            return;
        }

        const activeCount = Math.min(listItems.length, thumbnails.length);
        const controllers = [];

        const setActiveItem = (activeIndex) => {
            listItems.forEach((item, index) => {
                const isActive = index === activeIndex;
                item.classList.toggle('is-active', isActive);
                item.setAttribute('aria-selected', String(isActive));

                const itemName = item.querySelector('.item__name');
                if (itemName) {
                    itemName.classList.toggle('is-active', isActive);
                }
            });

            thumbnails.forEach((thumbnail, index) => {
                const isActive = index === activeIndex;
                thumbnail.hidden = !isActive;
                thumbnail.classList.toggle('is-active', isActive);
            });
        };

        const setupEvents = () => {
            // Apply initial accessibility & styling attributes
            listItems.slice(0, activeCount).forEach((item, index) => {
                item.setAttribute('role', 'button');
                item.setAttribute('tabindex', '0');
                item.setAttribute('aria-selected', 'false');
                item.style.cursor = 'pointer';

                // Use AbortController for clean event removal when returning to mobile
                const controller = new AbortController();
                controllers.push(controller);

                item.addEventListener('click', () => setActiveItem(index), { signal: controller.signal });

                item.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        setActiveItem(index);
                    }
                }, { signal: controller.signal });
            });

            setActiveItem(0);
        };

        const teardownEvents = () => {
            // Remove event listeners
            controllers.forEach(controller => controller.abort());
            controllers.length = 0;

            // Reset modified styles & attributes for mobile
            listItems.forEach((item) => {
                item.removeAttribute('role');
                item.removeAttribute('tabindex');
                item.removeAttribute('aria-selected');
                item.style.cursor = '';
                item.classList.remove('is-active');

                const itemName = item.querySelector('.item__name');
                if (itemName) itemName.classList.remove('is-active');
            });

            thumbnails.forEach((thumbnail) => {
                thumbnail.hidden = false;
                thumbnail.classList.remove('is-active');
            });
        };

        const handleBreakpointChange = (e) => {
            if (e.matches) {
                setupEvents();
            } else {
                teardownEvents();
            }
        };

        // Initial check and listener registration
        if (mediaQuery.matches) {
            setupEvents();
        }

        mediaQuery.addEventListener('change', handleBreakpointChange);
    });
};